export default __webpack_public_path__ + "static/media/hyper-efficient.633cdcd8.png";